<div class="content content--narrow">
    <div class="tile mt-0200 p-0150 pl-0200 pr-0200">
        <h2 class="h2 mt-0075 align-center">Which campaign do you want to organize?</h2>
        <p class="mt-0075 mb-0075 align-center">You haven't selected a campaign.</p>
        <app-campaign-switcher class="d-block m-0 w-100 max-width-100"></app-campaign-switcher>
    </div>
</div>
